import { render, staticRenderFns } from "./ownerDetailOweFee.vue?vue&type=template&id=0733e1ed&scoped=true"
import script from "./ownerDetailOweFee.vue?vue&type=script&lang=js"
export * from "./ownerDetailOweFee.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailOweFee.vue?vue&type=style&index=0&id=0733e1ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0733e1ed",
  null
  
)

export default component.exports